import React from 'react'

import ProcessesViewModeWrapper from '../shared/ProcessesViewModeWrapper'
import PageContent from './PageContent'

const ProcessesKanbanPage = ({ id }) => {
  return (
    <ProcessesViewModeWrapper id={id}>
      <PageContent id={id} />
    </ProcessesViewModeWrapper>
  )
}

export default ProcessesKanbanPage
